import cn from "classnames";
import { ending } from "helpers/i18n";
import { formatNumber } from "helpers/system";
import React, { useEffect, useState } from "react";
import { getPaymentStats } from "sources/books/cargoOwners";

const periodDays = [30, 60, 90, 180, 365];

function OverdueRangeModal(props) {
    const setDays = (days) => {
        props.setDays(days);
        props.back();
    };
    return (
        <>
            {periodDays.map((days) => (
                <div
                    className="d-flex align-items-center font-size-14 cursor-pointer"
                    key={days}
                    onClick={() => setDays(days)}
                >
                    <span
                        className={cn("checkbox checkbox--inline mr-2", {
                            "checkbox--checked": props.days === days,
                        })}
                        name={days}
                    />
                    {days} дней
                </div>
            ))}
            <div className="d-flex align-items-center font-size-14 cursor-pointer" onClick={() => setDays(undefined)}>
                <span
                    className={cn("checkbox checkbox--inline mr-2", {
                        "checkbox--checked": props.days === undefined,
                    })}
                />
                За все время
            </div>
        </>
    );
}

export default function CounterpartyInfo(props) {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [days, setDays] = useState(90);
    useEffect(() => {
        setLoading(true);
        getPaymentStats(props.id, days).then((response) => {
            setData(response);
            setLoading(false);
        });
    }, [props.id, days]);

    const openOverdueRangeModal = () => {
        props.modal({
            name: "default",
            title: "Выбор периода расчета",
            CustomBody: OverdueRangeModal,
            bodyData: { setDays, days },
        });
    };

    return (
        <div
            className={cn("ml-4 card card-body flex-grow-0 px-0 py-1 mt-3 w-fit-content", {
                "loading loading--small": loading,
            })}
        >
            <b className="px-2 small pb-2">Показатели контрагента {props.name}</b>
            <table className="table table-xs mb-0">
                <tbody>
                    <tr>
                        <td className="noborder text-muted">Период расчета:</td>
                        <td className="noborder">
                            {days ?? "∞"} {ending(data.averageOverdueDays, "день", "дня", "дней")}
                            <i
                                className="icon-uEA0C-gear inline-icon text-warning ml-3 font-size-14 cursor-poiner"
                                onClick={openOverdueRangeModal}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className="text-muted">Общая сумма за период:</td>
                        <td>
                            {formatNumber(data.planIncomeInPeriod, {
                                style: "currency",
                                currency: props.organization?.currency,
                            })}
                        </td>
                        <td className="text-muted pl-5">Средняя просрочка:</td>
                        <td>
                            {data.averageOverdueDays} {ending(data.averageOverdueDays, "день", "дня", "дней")}
                        </td>
                    </tr>
                    <tr>
                        <td className="text-muted">Оплачено:</td>
                        <td>
                            {formatNumber(data.receivedAmountInPeriod, {
                                style: "currency",
                                currency: props.organization?.currency,
                            })}
                        </td>
                        <td className="text-muted pl-5">Долг:</td>
                        <td>
                            {formatNumber(data.totalDebt, {
                                style: "currency",
                                currency: props.organization?.currency,
                            })}
                        </td>
                    </tr>
                    <tr>
                        <td className="text-muted">Ожидаемая оплата:</td>
                        <td>
                            {formatNumber(data.pendingPaymentsInPeriod, {
                                style: "currency",
                                currency: props.organization?.currency,
                            })}
                        </td>
                        <td className="text-muted pl-5">Количество просроченных заявок:</td>
                        <td>
                            {data.overdueBidsCount} {ending(data.overdueBidsCount, "заявка", "заявки", "заявок")}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
